import { isAlertVisibleToRole } from '@backoffice-frontend/alerts-common'
import {
  FccAdAlertStatus,
  FccAdAlertType,
  type FccOperatorRoleType,
} from '@backoffice-frontend/graphql'
import type { AdAlertFeedVehicleFragment } from './AdAlertFeed.hook'
import type { AdAlertFeedCardAlertFragment } from './AdAlertFeedCard/AdAlertFeedCard.hook'

const OPERATOR_INITIATED_ALERTS: FccAdAlertType[] = [
  FccAdAlertType.OperatorToCabinCall,
  FccAdAlertType.OutgoingOperatorToSafetyDriverCall,
]

export type AlertFeedEntry = {
  vehicle: AdAlertFeedVehicleFragment
  alerts: AdAlertFeedCardAlertFragment[]
}

export const getActiveAlertsForRole = (
  vehicle: AdAlertFeedVehicleFragment,
  role: FccOperatorRoleType | undefined,
) =>
  vehicle.fccCurrentAdAlerts?.alerts.filter(
    alert =>
      alert.status !== FccAdAlertStatus.Closed &&
      isAlertVisibleToRole(alert, role),
  ) ?? []

export const getOldestAlertDate = (
  alerts: AdAlertFeedCardAlertFragment[],
): number =>
  alerts.reduce(
    (oldest, alert) => Math.min(oldest, new Date(alert.createdAt).getTime()),
    Date.now(),
  )

export const getAlertFeedEntries = (
  vehicles: AdAlertFeedVehicleFragment[],
  role: FccOperatorRoleType | undefined,
): AlertFeedEntry[] =>
  vehicles
    .map(vehicle => ({
      vehicle,
      alerts: getActiveAlertsForRole(vehicle, role),
    }))
    .filter(entry => entry.alerts.length > 0)
    .sort((a, b) => getOldestAlertDate(a.alerts) - getOldestAlertDate(b.alerts))

export const hasSoundWorthyAlert = (
  alerts: AdAlertFeedCardAlertFragment[],
): boolean =>
  alerts.some(alert => !OPERATOR_INITIATED_ALERTS.includes(alert.type))
